module.exports = __webpack_public_path__ + "95271b5b46637e93b7223f4008e0988a.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Glyphter.ttf
// module id = J1dA
// module chunks = 0